import { Box, CircularProgress } from '@mui/material';

export function RouteLoadingFallback() {
  return (
    <Box role="status" sx={{ display: 'grid', minHeight: '40vh', placeItems: 'center' }}>
      <CircularProgress size={28} />
    </Box>
  );
}
